<template>
    <h3 class="hh3">
        <slot></slot>
    </h3>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.hh3 {
    display: flex;
    font-size: 20px;
    color: #333;
    font-weight: 600;
    margin: 25px 0 15px;
    position: relative;
}

@media (max-width: 768px) {
    .hh3 {
        font-size: 18px;
        margin: 20px 0 12px;
    }
}
</style>